import React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './PageShell.css';

function PageShell({ children, loading = false }) {
  return (
    <div className="page-shell">
      <Header />
      <main className="main-content">
        {loading ? (
          <div className="loading-container">
            <div className="spinner">Loading...</div>
          </div>
        ) : (
          children
        )}
      </main>
      <Footer />
    </div>
  );
}

export default PageShell;

